/* High As — ajustes de interfaz */
(function () {
  /* Horizon ya escribe el nombre de la red en
     .social-icons__icon-label (lo esconde por CSS), asi que NO hay que
     inyectar nada: basta con enseñarlo desde high-as-extra.css.
     Aqui solo se corrigen dos nombres que salen feos del capitalize. */
  var RENAMES = {
    twitter: 'X',
    youtube: 'YouTube',
    tiktok: 'TikTok',
    linkedin: 'LinkedIn'
  };

  /* HIGH AS: marca la plantilla en el <body> (ha-tpl-page, ha-tpl-index,
     ha-tpl-blog, etc). El script inline de theme.liquid lo intenta ANTES
     de que exista #MainContent, asi que la clase no llegaba a ponerse y el
     sistema de cabecera fija/transparente de las paginas no se activaba.
     Aqui, con el DOM ya listo, se lee data-template y se anade la clase. */
  function initTemplateClass() {
    var mc = document.getElementById('MainContent');
    var tpl = mc ? (mc.getAttribute('data-template') || '') : '';
    var base = tpl.split('.')[0];
    if (base && !document.body.classList.contains('ha-tpl-' + base)) {
      document.body.classList.add('ha-tpl-' + base);
    }
  }

  function initCollectionDescription() {
    var main = document.querySelector("main[data-template^='collection']");
    if (!main) return;

    var section = main.querySelector("[id*='collection_description']");
    if (!section) return;
    if (section.querySelector('.ha-desc')) return;

    var target = section.querySelector('.rte') || section.querySelector('div');
    if (!target) return;
    if (target.textContent.trim().length < 40) return;

    var moreTxt = (window.HA_I18N && window.HA_I18N.more) || 'Más información';
    var lessTxt = (window.HA_I18N && window.HA_I18N.less) || 'Ocultar información';

    var wrapper = document.createElement('div');
    wrapper.className = 'ha-desc';
    wrapper.setAttribute('data-collapsed', 'true');

    var inner = document.createElement('div');
    inner.className = 'ha-desc__inner';

    target.parentNode.insertBefore(wrapper, target);
    inner.appendChild(target);

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'ha-desc__toggle';
    button.textContent = moreTxt;
    button.setAttribute('aria-expanded', 'false');

    wrapper.appendChild(button);
    wrapper.appendChild(inner);

    button.addEventListener('click', function () {
      var collapsed = wrapper.getAttribute('data-collapsed') === 'true';
      wrapper.setAttribute('data-collapsed', collapsed ? 'false' : 'true');
      button.setAttribute('aria-expanded', collapsed ? 'true' : 'false');
      button.textContent = collapsed ? lessTxt : moreTxt;
    });
  }

  /* Aqui vivian fixEmailPlaceholder y tagFooterColumns, que retocaban el pie
     de Shopify: buscaban "footer .footer-content" y su formulario de email.
     El pie es ha-footer y sections/footer-group.json solo monta esa seccion,
     que no tiene .footer-content, ni input de email, ni .social-icons, asi que
     las dos funciones no encontraban nada. Retiradas el 31-08-2026.
     Ese mismo dia se retiro addConsentCheckbox, que inyectaba una casilla de
     consentimiento en el newsletter: apuntaba al mismo pie inexistente y la
     casilla se ha descartado por diseño. El aviso legal del newsletter sigue
     en la letra pequeña de sections/ha-newsletter.liquid. */

  function fixSocialLabels() {
    var labels = document.querySelectorAll('footer .social-icons__icon-label');
    for (var i = 0; i < labels.length; i++) {
      var key = (labels[i].textContent || '').trim().toLowerCase();
      if (RENAMES[key]) labels[i].textContent = RENAMES[key];
    }
  }

  /* El selector de pais y divisa del footer se envia solo al cambiarlo */
  function initLocalization() {
    var selects = document.querySelectorAll('.ha-localization__select');
    for (var i = 0; i < selects.length; i++) {
      if (selects[i].dataset.haBound === '1') continue;
      selects[i].dataset.haBound = '1';
      selects[i].addEventListener('change', function () {
        if (this.form) this.form.submit();
      });
    }
  }

  /* FAQ: al llegar con un ancla (p. ej. /pages/faq#pagos) se preselecciona
     esa pestaña. El HTML/JS de las pestañas vive en el contenido de la
     pagina; aqui solo se dispara el click en la pestaña cuyo data-cat
     coincide con el ancla y se lleva la vista a la seccion. */
  function initFaqAnchor() {
    var tabs = document.querySelectorAll('.ha-f .hf-tab');
    if (!tabs.length) return;
    var h = (window.location.hash || '').replace('#', '').toLowerCase();
    if (!h) return;
    for (var i = 0; i < tabs.length; i++) {
      if ((tabs[i].getAttribute('data-cat') || '').toLowerCase() === h) {
        tabs[i].click();
        var sec = tabs[i].closest('.hf-sec') || tabs[i];
        if (sec && sec.scrollIntoView) {
          try { sec.scrollIntoView({ behavior: 'instant', block: 'start' }); }
          catch (e) { sec.scrollIntoView(); }
        }
        break;
      }
    }
  }

  /* El enlace "Métodos de pago" del footer sale de un menu de Shopify y
     apunta a /pages/faq. Aqui se le añade el ancla #pagos para que la FAQ
     abra directamente esa categoria (sin tocar la navegacion de la tienda).
     Se detecta por la URL (/pages/faq) y por el texto del enlace, que puede
     venir en cualquier idioma publicado. */
  function initFooterFaqAnchor() {
    var payTxt = (window.HA_I18N && window.HA_I18N.payments) || 'metodos de pago,métodos de pago,payment methods,payments,moyens de paiement,zahlungsarten,metodi di pagamento';
    var payList = payTxt.toLowerCase().split(',');
    var links = document.querySelectorAll('.ha-foot a, footer a');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var t = (a.textContent || '').trim().toLowerCase();
      var isPay = false;
      for (var k = 0; k < payList.length; k++) {
        var needle = payList[k].trim();
        if (needle && t.indexOf(needle) > -1) { isPay = true; break; }
      }
      if (!isPay) continue;
      var href = a.getAttribute('href') || '';
      if (href.indexOf('/pages/faq') > -1 && href.indexOf('#') === -1) {
        a.setAttribute('href', href + '#pagos');
      }
    }
  }

  /* Cada bloque va aislado. Este fichero se carga con defer, asi que init()
     corre de forma sincrona nada mas cargar: si una sola de estas funciones
     lanzara una excepcion, se abortaria el script entero y se perderia todo
     lo que viene detras. Con esto un fallo en una funcion no tumba al resto.
     El comportamiento de cada funcion no cambia. */
  function safe(fn) {
    try { fn(); } catch (e) {}
  }

  function init() {
    safe(initTemplateClass);
    safe(initCollectionDescription);
    safe(fixSocialLabels);
    safe(initLocalization);
    safe(initFooterFaqAnchor);
    safe(initFaqAnchor);
  }

  safe(initTemplateClass);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

/* High As — al pulsar "Añadir al carrito", en vez de recargar a /cart, se
   abre el CARRITO LATERAL NATIVO del tema (theme-drawer #cart-drawer). Se
   hace la peticion por AJAX con Section Rendering, se refresca el contenido
   del drawer y se abre, sin sacar al cliente de la pagina. */
(function () {
  if (window.__haCartOpen) return;
  window.__haCartOpen = true;

  var SECTION = 'cart-drawer-section';

  function isAddForm(f) {
    if (!f || f.tagName !== 'FORM') return false;
    var a = f.getAttribute('action') || '';
    return a.indexOf('/cart/add') !== -1;
  }

  function updateSection(html) {
    var host = document.getElementById('shopify-section-' + SECTION);
    if (!host || !html) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var inner = parsed.getElementById('shopify-section-' + SECTION);
    host.innerHTML = inner ? inner.innerHTML : html;
  }

  function openDrawer() {
    var d = document.getElementById('cart-drawer');
    if (d && typeof d.open === 'function') { d.open(); return; }
    var opener = document.querySelector('[aria-controls="cart-drawer"]');
    if (opener) opener.click();
  }

  /* Refuerzo del contador de la cabecera (Horizon suele actualizarlo solo,
     pero por si acaso lo sincronizamos con /cart.js). */
  function syncBubble() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = cart.item_count;
        var els = document.querySelectorAll('.cart-bubble__text-count,[data-cart-count],.cart-count');
        for (var i = 0; i < els.length; i++) { els[i].textContent = n; }
        var icon = document.querySelector('cart-icon');
        if (icon) {
          if (n > 0) icon.classList.add('header-actions__cart-icon--has-cart');
          else icon.classList.remove('header-actions__cart-icon--has-cart');
        }
      })
      .catch(function () {});
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!isAddForm(form)) return;
    e.preventDefault();
    var btn = form.querySelector("[type='submit']");
    if (btn) btn.disabled = true;
    var fd = new FormData(form);
    fd.append('sections', SECTION);
    fd.append('sections_url', location.pathname);
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw j; });
        return r.json();
      })
      .then(function (data) {
        if (data.sections && data.sections[SECTION]) updateSection(data.sections[SECTION]);
        openDrawer();
        syncBubble();
        if (window.haCurrency) window.haCurrency.apply();
      })
      .catch(function () {
        /* si algo falla, no bloqueamos: envio normal del formulario */
        try { form.submit(); } catch (e2) {}
      })
      .then(function () { if (btn) btn.disabled = false; });
  }, true);
})();
